import { useEffect, useState } from "react";
import GenericTemplate from "../templates/GenericTemplate";
import * as commonFnc from '../common/commonFnc';
import { Box, Typography, Button } from "@mui/material";
import ShiftCountGroupMstEditList from "../conponents/shiftCountGroupMstPage/ShiftCountGroupMstEditList";
import ShiftCountGroupMstEditDialog from "../conponents/shiftCountGroupMstPage/ShiftCountGroupMstEditDialog";



// name: Mst_shiftCountGroupMstPage
// summary: シフトカウントグループマスタ編集画面
const Mst_shiftCountGroupMstPage = (props) =>{
    
    // 01_props
    const {
        setLogin_user_id, 
        setKintai_bscs, 
        Login_user_info, 
        setDisplay_user_info,
    } = props;


    
    // 02_useState
    const [shiftMsts, setShiftMsts] = useState([]);
    const [shiftCountGroupMsts, setShiftCountGroupMsts] = useState([]);
    const [shiftCountGroupMappings, setShiftCountGroupMappings] = useState([]);

    const [selectedShiftCountGroupItem, setSelectedShiftCountGroupItem] = useState({});


    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(()=>{
        const run = async () => {
            try {
                const [resShiftMst, resGroupMst, resMapping] = await Promise.all([
                    fetch(`/api/select/shift_mst`),
                    fetch(`/api/select/shiftCountGroupMst`),
                    fetch(`/api/select/shiftCountGroupMapping`),
                ]);
                const [shiftMstData, groupMstData, mappingData] = await Promise.all([
                    resShiftMst.json(),
                    resGroupMst.json(),
                    resMapping.json(),
                ]);
                setShiftMsts(shiftMstData);
                setShiftCountGroupMsts(groupMstData);
                setShiftCountGroupMappings(mappingData);
            } catch (error) {
                console.error(error);
            }
        };
        run();
    },[]);

    // シフトカウントグループマスタ操作
    // - 追加
    const handleAddShiftCountGroup = () => {
        setSelectedShiftCountGroupItem({});
        setDialogOpen(true);
    }
    // - 編集
    const handleEditShiftCountGroup = () => {
        if(!selectedShiftCountGroupItem || !selectedShiftCountGroupItem.shift_count_group_cd){
            alert("シフトカウントグループを選択してください。");
            return;
        }
        setDialogOpen(true);
    }
    // - 削除
    const handleDeleteShiftCountGroup = (logDelFlg) => {
        if(!selectedShiftCountGroupItem || !selectedShiftCountGroupItem.shift_count_group_cd){
            alert("シフトカウントグループを選択してください。");
            return;
        }
        submitShiftCountGroupMst(
            selectedShiftCountGroupItem.shift_count_group_cd,
            selectedShiftCountGroupItem.shift_count_group_name,
            selectedShiftCountGroupItem.note,
            logDelFlg
        );
    }
    
    // - 選択（クリック）
    const handleOnClickShiftCountGroup = (shiftCountGroupItem) => {
        console.log(shiftCountGroupItem);
        setSelectedShiftCountGroupItem(shiftCountGroupItem);
    }

    // ダイアログ操作
    // - 更新処理
    const submitShiftCountGroupMst = async (shiftCountGroupCd, shiftCountGroupName, shiftCountGroupDescription, logDelFlg) => {
        console.log("登録");
        try {
            console.log(shiftCountGroupCd, shiftCountGroupName, shiftCountGroupDescription)
            const response = await fetch(`/api/insert/shiftCountGroupMst`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    userId: Login_user_info.user_id,
                    shiftCountGroupCd: shiftCountGroupCd,
                    shiftCountGroupName: shiftCountGroupName,
                    note: shiftCountGroupDescription,
                    logDelFlg: logDelFlg,
                }),
            });
            if (!response.ok) {
                console.log('データの登録に失敗しました。');
                throw new Error('データの登録に失敗しました。');
            }

            
            const res = await fetch(`/api/select/shiftCountGroupMst`);
            const data = await res.json();
            setShiftCountGroupMsts(data);

            alert("登録に成功しました。");
        } catch (error) {
            console.error(error);
            alert("登録に失敗しました。");
            
        }finally{
            setDialogOpen(false);
        }
    }

    // - 登録
    const handleSubmitDialog = (shiftCountGroupCd, shiftCountGroupName, shiftCountGroupDescription) => {
        submitShiftCountGroupMst(
            shiftCountGroupCd,
            shiftCountGroupName,
            shiftCountGroupDescription,
            false);
    }

    // - 閉じる
    const handleCloseDialog = () => {
        setDialogOpen(false);
        setSelectedShiftCountGroupItem({});
    }


    // - シフトマスタ操作
    const handleOnDoubleClickShiftMst = async (shiftMstItem) => {

        if(!selectedShiftCountGroupItem || !selectedShiftCountGroupItem.shift_count_group_cd){
            
            return;
        }
        try {
            const response = await fetch(`/api/insert/shiftCountGroupMapping`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    userId: Login_user_info.user_id,
                    shiftCountGroupCd: selectedShiftCountGroupItem.shift_count_group_cd,
                    shiftTypeCd: shiftMstItem.shift_type_cd,
                    logDelFlg: false,
                }),
            });

            if (!response.ok) {
                console.log('データの登録に失敗しました。');
                throw new Error('データの登録に失敗しました。');
            }

            const res = await fetch(`/api/select/shiftCountGroupMapping`);
            const data = await res.json();
            setShiftCountGroupMappings(data);
        } catch (error) {
            console.error(error);
        }
    }

    // - マッピング操作
    const handleOnDoubleClickShiftCountGroupMapping = async (shiftCountGroupMappingItem) => {
        if(!selectedShiftCountGroupItem || !selectedShiftCountGroupItem.shift_count_group_cd){
            return;
        }
        try {
            const response = await fetch(`/api/deleteOne/ShiftCountGroupMapping`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    _id: shiftCountGroupMappingItem._id,
                    shiftCountGroupCd: shiftCountGroupMappingItem.shift_count_group_cd,
                    shiftTypeCd: shiftCountGroupMappingItem.shift_type_cd,
                }),
            });

            if (!response.ok) {
                console.log('データの削除に失敗しました。');
                throw new Error('データの削除に失敗しました。');
            }

            const res = await fetch(`/api/select/shiftCountGroupMapping`);
            const data = await res.json();
            setShiftCountGroupMappings(data);
        } catch (error) {
            console.error(error);
        }
    }


    


    
    const styles = {
        note_wrapper:{
            padding:"10px",
            marginBottom:"10px"
        },
        list_item_wrapper:{
            display:"flex",
            padding:"10px"
        },
        title_wrapper:{
            display:"flex"
        },
        title:{
            flexGrow:1,
        },
        button_wrapper:{
            display:"flex"
        },
        button:{
            marginRight:"10px",
            backgroundColor:"#9CCC66",
            "&:hover":{
                backgroundColor:"#8DBB5A",
            }
        },
        shift_count_group_container:{
            minWidth:"40%",
            marginRight:"50px"
        },
        shift_mst_container:{
            minWidth:"40%",
            marginRight:"50px"
        },
    }

    return (
        <GenericTemplate title="グループ集計マスタ管理"
            setLogin_user_id={setLogin_user_id}
            setKintai_bscs={setKintai_bscs}
            Login_user_info={Login_user_info}
            setDisplay_user_info={setDisplay_user_info}
        >
            <Box sx={styles.note_wrapper}>
                <Typography variant="p"> CSV出力時にグループごとに集計できます。</Typography>
                <Typography variant="p"> 1日勤務：1日 半日勤務:0.5日</Typography>
            </Box>
            <Box className="edit_wrapper">
                <Box className="list_item_wrapper" sx={styles.list_item_wrapper}>
                    <Box className="shift_count_group_container" sx={styles.shift_count_group_container}>
                        <Box className="list_item_container">
                            <Box className="title_wrapper" sx={styles.title_wrapper}>
                                <Typography variant="h6" sx={styles.title}>グループ集計一覧</Typography>
                                <Box className="button_wrapper" sx={styles.button_wrapper}>
                                    <Button sx={styles.button} variant="contained" onClick={()=>handleAddShiftCountGroup()}>追加</Button>
                                    <Button sx={styles.button} variant="contained" onClick={()=>handleEditShiftCountGroup()}>編集</Button>
                                    {!selectedShiftCountGroupItem || !selectedShiftCountGroupItem.log_del_flg===true?
                                    <Button sx={styles.button} variant="contained" onClick={()=>handleDeleteShiftCountGroup(true)}>削除</Button>
                                    :
                                    <Button sx={styles.button} variant="contained" onClick={()=>handleDeleteShiftCountGroup(false)}>戻す</Button>
                                    }
                                </Box>
                            </Box>
                            <Typography variant="p" sx={styles.title}>グループ集計項目を選択してください</Typography>
                            <ShiftCountGroupMstEditList
                                list={shiftCountGroupMsts}
                                includeLsit={[]}
                                height={"300px"}
                                keyName={"shift_count_group_cd"}
                                name1={"shift_count_group_name"}
                                name2={"note"}
                                sortKey={"seq"}
                                selectedKey={selectedShiftCountGroupItem?.shift_count_group_cd}
                                handleOnClick={handleOnClickShiftCountGroup}
                                handleOnDoubleClick={null}
                            />
                        </Box>
                        <Box className="list_item_container">
                            <Box className="title_wrapper" sx={styles.title_wrapper}>
                                <Typography variant="h6" sx={styles.title}>含まれるシフト一覧</Typography>
                            </Box>
                            <Typography variant="p" sx={styles.title}>ダブルクリックでグループから削除します。</Typography>
                            <ShiftCountGroupMstEditList
                                list={shiftCountGroupMappings.filter((item)=>item.shift_count_group_cd===selectedShiftCountGroupItem?.shift_count_group_cd)}
                                includeLsit={[]}
                                height={"300px"}
                                keyName={"shift_type_cd"}
                                name1={"shift_name"}
                                name2={"shift_group_cd"}
                                sortKey={"seq"}
                                selectedKey={null}
                                handleOnClick={null}
                                handleOnDoubleClick={handleOnDoubleClickShiftCountGroupMapping}
                            />
                        </Box>
                    </Box>
                    <Box className="shift_mst_container" sx={styles.shift_mst_container}>
                        <Box className="list_item_container">
                            <Box className="title_wrapper" sx={styles.title_wrapper}>
                                <Typography variant="h6" sx={styles.title}>シフト一覧</Typography>
                            </Box>
                            <Typography variant="p" sx={styles.title}>ダブルクリックでグループに追加します。</Typography>
                            <ShiftCountGroupMstEditList
                                list={shiftMsts.filter((item)=>item.log_del_flg===false)}
                                includeLsit={shiftCountGroupMappings.filter((item)=>item.shift_count_group_cd===selectedShiftCountGroupItem?.shift_count_group_cd).map((item)=>item.shift_type_cd)}
                                height={"675px"}
                                keyName={"shift_type_cd"}
                                name1={"shift_name"}
                                name2={"shift_group_cd"}
                                sortKey={"seq"}
                                selectedKey={null}
                                handleOnClick={null}
                                handleOnDoubleClick={handleOnDoubleClickShiftMst}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        
            <ShiftCountGroupMstEditDialog
                dialogOpen={dialogOpen}
                onClose={handleCloseDialog}
                onSubmit={handleSubmitDialog}
                shiftCountGroupItem={selectedShiftCountGroupItem}
            />

        </GenericTemplate>
    );
}

export default Mst_shiftCountGroupMstPage;